export const SORTABLE_DIRECTION = {
    HORIZONTAL: 'HORIZONTAL',
    VERTICAL: 'VERTICAL',
};

export const SORTABLE_POSITION = {
    BEFORE: 'BEFORE',
    AFTER: 'AFTER',
};

export const CHANGE_TYPE = {
    UPDATE: 'update',
    ADD: 'add',
    REMOVE: 'remove',
};

export const defaultClassNames = {
    nativeSortable: 'native-sortable',
    draggable: 'native-sortable__item',
    ghost: 'native-sortable__ghost',
    remove: 'native-sortable__remove',

    targetClassName: 'native-sortable__target',
    targetRight: 'native-sortable__target_right',
    targetLeft: 'native-sortable__target_left',
    targetTop: 'native-sortable__target_top',
    targetBottom: 'native-sortable__target_bottom',
};

export const defaultDataIdAttr = 'id';

export const defaultGroupRole = 'NativeSortable';
